import { Theme } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../../assets';

type Props = {
  previewSize: {
    width: number;
    height: number;
  };
};

export const useStyles = makeStyles<Theme, Props>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    gap: 16,
  },
  iconItem: {
    display: 'flex',
    alignSelf: 'center',
  },
  fileIconWrapper: {
    display: 'flex',
  },
  fileIcon: {
    width: ({ previewSize }) => previewSize.width,
    height: ({ previewSize }) => previewSize.height,
  },
  previewContainer: {
    width: ({ previewSize }) => previewSize.width,
    height: ({ previewSize }) => previewSize.height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: colors.grey10,
    borderRadius: 4,
  },
  preview: {
    width: ({ previewSize }) => previewSize.width,
    height: ({ previewSize }) => previewSize.height,
    objectFit: 'cover',
  },
  pdfThumbnail: {
    width: ({ previewSize }) => previewSize.width,
    height: ({ previewSize }) => previewSize.height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& canvas': {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },
  },
  pdfPreviewLoading: {
    width: ({ previewSize }) => previewSize.width,
    height: ({ previewSize }) => previewSize.height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.grey10,
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '140%',
  },
  description: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '140%',
    color: colors.grey140,
  },
  removeIconButton: {
    padding: 6,
    margin: -6,
  },
}));
